<div class="modal-header" id="app-notification-modal-title">
    <h3 class="modal-title" id="modal-title">{{ model.titleText }}</h3>
</div>
<div class="modal-body" id="modal-body">
    <div class="d-flex flex-column w-100">
        <p class="user-select-auto text-start w-100" [innerHTML]="model.bodyText"></p>
    </div>
</div>
<div class="modal-footer">
    @if (model.type === 2 && displayReportAnIssueButton) {
        <button class="btn btn-primary" type="button" (click)="openReportIssue()">
            {{ 'MODAL_REPORT_ISSUE' | translate }}
        </button>
    }
    <button class="btn btn-primary" type="button" (click)="okClick()">{{ 'MODAL_OK' | translate }}</button>
</div>
